import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'
import axios from 'axios'
import VueSignature from "vue-signature-pad"

axios.defaults.baseURL = process.env.VUE_APP_REST_API_BASE_URL
Vue.config.productionTip = false
Vue.use(VueSignature);

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
})
.$mount('#app')
